export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'orcamento-empresa' ||
    columnId === 'orcamento-ano' ||
    columnId === 'orcamento-empresa' ||
    columnId === 'orcamento-loja' ||
    columnId === 'orcamento-categoria'
  )
}
